import styled from 'styled-components';

import { styledInteraction, styledMedia, styledReset } from '@pkg/primitives';

import { tokens } from '../../tokens';

// CSS Custom Properties are inherited from the
// `navCssVars` on the parent <EmojiPicker />.
export const StyledNavigation = styled.nav``;

export const List = styled.ul`
    ${styledReset.list};
    display: grid;
    grid-template-columns: repeat(${tokens.nav.list.columns}, auto);
    justify-content: space-between;
    gap: ${tokens.nav.list.gap}px;
`;

export const Item = styled.li`
    flex: 0 0 auto;
`;

export const Action = styled.button.attrs({ type: 'button' })`
    ${styledReset.button};
    ${styledInteraction.focusRing({ offset: -4, radius: 999 })};

    display: grid;
    place-items: center;
    width: ${tokens.nav.item.size}px;
    height: ${tokens.nav.item.size}px;
    background-color: var(--yat_emoji-picker-nav-action-bg-color);
    border-radius: 999px;
    transition-property: background-color, opacity;
    transition-duration: 200ms;
    transition-timing-function: ease-in-out;

    &:focus,
    &:hover {
        background-color: var(--yat_emoji-picker-nav-action-bg-color-hover);
    }

    &:active {
        background-color: var(--yat_emoji-picker-nav-action-bg-color-active);
    }

    &[aria-pressed='true'] {
        background-color: var(--yat_emoji-picker-nav-action-bg-color-pressed);
        opacity: 0.8;

        &:hover {
            opacity: 1;
        }

        &:active {
            opacity: 0.8;
        }
    }

    &[disabled] {
        opacity: 0.6;
        pointer-events: none;
    }
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${tokens.nav.icon.size}px;
    height: ${tokens.nav.icon.size}px;
    color: var(--yat_emoji-picker-nav-icon-color);
    transition: color 200ms ease-in-out;

    ${Action}[aria-pressed='true'] & {
        color: var(--yat_emoji-picker-nav-icon-color-pressed);
    }
`;
